import { gql } from '@apollo/client';

const SUPPORT_TOPIC_FRAGMENT = gql`
  fragment BaseSupportTopic on SupportTopic {
    id
    title
    description
    sortIndex
  }
`;

export default SUPPORT_TOPIC_FRAGMENT;
